import ProjectList from 'components/ProjectList';
import Page from 'components/Page';

const ProjectsPage = () => {
  return (
    <Page>
      <ProjectList />
    </Page>
  )
}

export default ProjectsPage;
